"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CompleteInvestigateTimeout;
require("core-js/modules/es.function.name.js");
function CompleteInvestigateTimeout(data) {
  this.name = 'BunnyPublisherTimeoutException';
  this.data = data;
  this.message = JSON.stringify(data);
  this.stack = new Error().stack;
}
CompleteInvestigateTimeout.constructor = CompleteInvestigateTimeout;